





























































































































import { formatDate } from '@/utils/helpers'
import { defineComponent, reactive } from '@vue/composition-api'
import type { Header } from '@/components/composables/useDataTable/types'
import { useDataTable } from '@/components/composables/useDataTable'
import InvoiceListService from '@/services/invoice/index'
import PaymentForm from '@/views/Invoice/PaymentForm.vue'
import InvoicePayments from '@/views/Invoice/InvoicePayments.vue'
import InvoiceStatus from '@/views/Invoice/components/InvoiceStatus.vue'
import InvoiceService from '@/services/clientInvoice'
import InvoiceForm from '@/views/Invoice/InvoiceForm.vue'
import StatCard from '@/components/Stats/StatCard.vue'

export default defineComponent({
  name: 'InvoicesList',
  setup() {
    const searchParams = reactive({ type: 'buy' })
    const { items, totalRecords, loading, pagination, search, query, pages, fetchData } = useDataTable(
      InvoiceListService,
      searchParams,
    )

    return {
      items,
      totalRecords,
      loading,
      pagination,
      search,
      query,
      pages,
      fetchData,
      formatDate,
      searchParams,
    }
  },
  components: {
    InvoiceForm,
    StatCard,
    InvoiceStatus,
    PaymentForm,
    InvoicePayments,
  },
  data(): {
    selected: never[]
    statistics: { paidAmount: number; unpaidAmount: number; sumAmount: number }
    statsLoading: boolean
    typeToggleIndex: number
  } {
    return {
      selected: [],
      statistics: { paidAmount: 0, unpaidAmount: 0, sumAmount: 0 },
      statsLoading: true,
      typeToggleIndex: 0,
    }
  },
  computed: {
    headers(): Array<Header> {
      return [
        { value: 'procurement.id', text: this.$t('tenderId'), sortable: true },
        { value: 'procurement.name', text: this.$t('tenderTitle'), sortable: true },
        { value: 'procurement.isPublishedAt', text: this.$t('date'), sortable: true },
        { value: 'value', text: this.$t('total'), sortable: true, align: 'end' },
        { value: 'paid', text: this.$t('paid'), sortable: true, align: 'end' },
        { value: 'remaining', text: this.$t('remaining'), sortable: true, align: 'end' },
        { value: 'status', text: this.$t('status'), sortable: true },
        {
          value: 'actions',
          text: this.$t('actions'),
          sortable: false,
          align: 'end',
          width: '160px',
          cellClass: 'text-no-wrap',
        },
      ]
    },
  },
  methods: {
    formatAmount(value: number | string): string {
      const parsedValue = Number(value)
      const amount = Number.isFinite(parsedValue) ? parsedValue : 0

      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount)
    },
    fetchInvoices(invoiceType: string) {
      this.searchParams.type = invoiceType
      this.fetchData()
    },
    async fetchStatistics() {
      this.statsLoading = true
      const { data } = await InvoiceService.allStatistics(this.searchParams.type)
      this.statistics = data.data
      this.statsLoading = false
    },
    refresh() {
      this.fetchStatistics()
      this.fetchData()
    },
  },
  watch: {
    totalRecords: function () {
      this.fetchStatistics()
    },
    typeToggleIndex(idx: number): void {
      this.fetchInvoices(idx === 1 ? 'sell' : 'buy')
    },
  },
})
